export const REPORTS_TRANSLATIONS = {
  Reports: "Reports",

  lastReports: "Last {{count}} reports",
  lastReports_zero: "No reports available",
  lastReports_one: "Last report",

  report_type_farm_animals: "General Animals Report",
  report_type_individual_animal: "Individual Animal Report",
  report_type_farm: "Farm Report",
  report_type_apiary: "Apiary Report",
  report_type_crops: "Crops Report",
  newReport: "New Report",
  download: "Download",
  view: "View",
  generateReport: "Generate Report",
}
